import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";
import "./styles/MenuPage.css";
import { fetchMenuItems } from "./slices/MenuItemsSlice";
import { logEvent } from "./analytics"; // ✅ import logEvent

const MenuPage = () => {
  const [activeItem, setActiveItem] = useState(null);
  const dispatch = useDispatch();
  const { menuItems } = useSelector((state) => state.menuItems);

  useEffect(() => {
    dispatch(fetchMenuItems());
  }, [dispatch]);

  const handleToggle = (uniqueKey, item) => {
    setActiveItem((prev) => (prev === uniqueKey ? null : uniqueKey));

    // ✅ Track click in GA
    logEvent({
      category: "Menu Item",
      action: "Clicked",
      label: item.name,
    });
  };

  const groupedMenu = menuItems.reduce((acc, item) => {
    const category = item.category || "Other";
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(item);
    return acc;
  }, {});

  return (
    <div className="menu-wrapper">
      <Helmet>
        <title>Our Menu | Chai n Chill</title>
        <meta
          name="description"
          content="Explore our delicious chai-inspired menu — from classic masala chai to unique blends, snacks, and desserts."
        />
        <meta
          name="keywords"
          content="chai menu, tea shop, cafe menu, masala chai, snacks, desserts"
        />
        <meta property="og:title" content="Our Menu | Chai n Chill" />
        <meta
          property="og:description"
          content="Discover all the chai and treats available at Chai n Chill."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://yourdomain.com/menu" />
        <meta
          property="og:image"
          content="https://yourdomain.com/images/menu-preview.jpg"
        />
      </Helmet>

      <div className="menu-page">
        <h1 className="menu-title">Our Menu</h1>

        {Object.entries(groupedMenu).map(([section, items]) => (
          <div className="menu-section" key={section}>
            <h2>{section}</h2>
            <ul>
              {items.map((item, index) => {
                const uniqueKey = `${section}-${item.id || index}`;
                return (
                  <li
                    key={uniqueKey}
                    onClick={() => handleToggle(uniqueKey, item)} // ✅ pass item for GA
                    className={activeItem === uniqueKey ? "active" : ""}
                  >
                    <div
                      className={`menu-item-row ${
                        activeItem === uniqueKey ? "active" : ""
                      }`}
                    >
                      <span>{item.name}</span>
                      <span>{item.price}</span>
                    </div>

                    {activeItem === uniqueKey && (
                      <div className="menu-popup">
                        <img src={item.imageUrl} alt={item.name} />
                        <p>{item.description}</p>
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MenuPage;
